import { render, staticRenderFns } from "./CriteriaCreate.vue?vue&type=template&id=6b0a4e9f"
import script from "./CriteriaCreate.vue?vue&type=script&lang=js"
export * from "./CriteriaCreate.vue?vue&type=script&lang=js"
import style0 from "./CriteriaCreate.vue?vue&type=style&index=0&id=6b0a4e9f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports